import * as React from 'react';
import * as models from '@app/models';
import { Grid, TextField, Typography } from '@material-ui/core';
import { Field } from 'formik';
import { injectIntl } from 'react-intl';
import * as _ from 'lodash';
import classNames from 'classnames';

const UspsShipTierOverrideComponent: React.FunctionComponent<models.ITierOverrideProps> = React.forwardRef(
	(props, ref: React.MutableRefObject<any>) => {
		return (
			<Grid container={true} justifyContent='center' alignItems='center'>
				<Grid item={true} sm={12} className='mt-2'>
					<>
                        <Grid container={true} item={true} xs={12} className='mb-1' alignItems='center'>
                            <Typography noWrap={true} color={'inherit'} variant='body1' className={classNames('display-inline-block')}>
                                {props.intl.formatMessage({
                                    id: 'app.carrier-account.USPS-Ship-app-section-header',
                                })}
                            </Typography>
                        </Grid>
						<Grid container={true} justifyContent='flex-start' alignItems='center' spacing={2}>
								<>
									<Grid item={true} sm={6} md={6} lg={6} xl={6}>
										<Field
											name='ConsumerKey'
											label={props.intl.formatMessage({
												id: 'app.carrier-account.config.USPSConsumerKey-label',
											})}
											variant='outlined'
											component={TextField}
											type='text'
											fullWidth={true}
											value={props.formikProps.values.ConsumerKey}
											onChange={(e: React.ChangeEvent) => props.formikProps.handleChange('ConsumerKey')(e)}
											error={
												!!(
													(props.formikProps.values.ConsumerKey?.length || props.formikProps.submitCount) &&
													!!props.formikProps.errors.ConsumerKey
												)
											}
											helperText={
												props.formikProps.values.ConsumerKey?.length || props.formikProps.submitCount
													? props.formikProps.errors.ConsumerKey
													: null
											}
										/>
									</Grid>
									<Grid item={true} sm={6} md={6} lg={6} xl={6}>
										<Field
											name='ConsumerSecret'
											variant='outlined'
											label={props.intl.formatMessage({
												id: 'app.carrier-account.config.USPSConsumerSecret-label',
											})}
											component={TextField}
											type='text'
											fullWidth={true}
											value={props.formikProps.values.ConsumerSecret}
											onChange={(e: React.ChangeEvent) => props.formikProps.handleChange('ConsumerSecret')(e)}
											error={
												!!(
													(props.formikProps.values.ConsumerSecret?.length || props.formikProps.submitCount) &&
													!!props.formikProps.errors.ConsumerSecret
												)
											}
											helperText={
												props.formikProps.values.ConsumerSecret?.length || props.formikProps.submitCount
													? props.formikProps.errors.ConsumerSecret
													: null
											}
										/>
									</Grid>
								</>
						</Grid>
					</>
				</Grid>
			</Grid>
		);
	}
);

export default injectIntl(UspsShipTierOverrideComponent, { withRef: true });



// WEBPACK FOOTER //
// ./src/components/carriers/usps-ship-tier-override.tsx